import classNames from 'classnames';
import type { PropsWithChildren } from 'react';

import { Spinner, type SpinnerProps } from '../Spinner/Spinner';

import './spinner-overlay.scss';

interface Props extends SpinnerProps, PropsWithChildren {
  isLoading: boolean;
  a11yLabel?: string;
  className?: string;
}

const SpinnerOverlaySpinner = ({ size = 'lg', a11yLabel }: { size: SpinnerProps['size']; a11yLabel?: string }) => {
  return (
    <div className="payflow-spinner-overlay__spinner" aria-label={a11yLabel}>
      <Spinner size={size} />
    </div>
  );
};

export const SpinnerOverlay = ({ size = 'lg', children, isLoading, a11yLabel, className }: Props) => {
  if (isLoading) {
    return (
      <div className={classNames('payflow-presentation payflow-spinner-overlay', className)}>
        <SpinnerOverlaySpinner size={size} a11yLabel={a11yLabel} />

        <div className="payflow-spinner-overlay__children busy" aria-busy="true">
          {children}
        </div>
      </div>
    );
  }

  if (className) {
    return <div className={className}>{children}</div>;
  }

  return children;
};

export const SpinnerOverlayNoRemount = ({ size = 'lg', children, isLoading, a11yLabel, className }: Props) => (
  <div className={classNames('payflow-presentation payflow-spinner-overlay', className)}>
    {isLoading && <SpinnerOverlaySpinner size={size} a11yLabel={a11yLabel} />}

    <div
      className={classNames('payflow-spinner-overlay__children', { busy: isLoading })}
      aria-busy={isLoading ? undefined : 'true'}
    >
      {children}
    </div>
  </div>
);
